import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  player: '',
  total_pages: 0,
  total_results: 0
};
export const useFileFetch = id => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use File fetch")
  console.log(id)
  useEffect(()=>{
    console.log("binne use File fetch se useEffect")
    const fetchFile = async()=>{
      try {
        setLoading(true);
        setError(false);
       
        const file = await API.fetchFile(id,accessToken)
       
        console.log(file)
        setState({  
          ...file.file[0]
          
        }
        )

        setLoading(false)

      } catch (error) {
        console.log(error)
        setError(true);
      }
    }
    fetchFile()
  },[]);

return{state,loading,error};


};
